// extracted by mini-css-extract-plugin
export default {"component":"styles__component--H2zhB","waveform":"styles__waveform--HYgS3","loaded":"styles__loaded--gMxX_","loader":"styles__loader--pZOZd"};